<template>

<app-wrapper class="head">

	<app-inner :row="true" class="head-inner">

		<com-social v-if="!window.is.mobile" />

		<com-logo />

		<com-menu />

	</app-inner>

</app-wrapper>

</template>

<script>

import comSocial from './head/Social'
import comLogo from './head/Logo'
import comMenu from './head/Menu'

export default {

	components: {
		'com-social': comSocial,
		'com-logo': comLogo,
		'com-menu': comMenu
	}

}

</script>

<style scoped>

.head {
	position: fixed;
	height: 64px;
	z-index: 3;
	background-color: #fff;
	border-bottom: 1px solid var(--color-grey-light);
}

.head-inner {
	justify-content: space-between;
}

.is-mobile .head-inner {
    justify-content: flex-end;
}

</style>